/**
 * editor2/shared/SectionHeader.tsx
 * セクションタイトルコンポーネント
 * VehicleDetailPanel の gc-section-title パターンに準拠
 */
import React from 'react';

interface SectionHeaderProps {
  title: string;
}

export default function SectionHeader({ title }: SectionHeaderProps) {
  return (
    <div
      className="gc-section-title"
      style={{
        fontSize: '0.95rem',
        fontWeight: 700,
        color: '#1e293b',
        letterSpacing: '0.02em',
        borderBottom: '2px solid #cbd5e1',
        paddingBottom: 6,
        marginTop: 18,
        marginBottom: 6,
      }}
    >
      {title}
    </div>
  );
}
